export const Language = {
    moneySignBeRight: false, //货币符号是否在后面
    moneySign: "Rs",

    newAPPVersionTip: "نیا ورژن دستیاب ہے۔ براہ مہربانی ریفریش کریں تاکہ کھیل جاری رکھ سکیں۔",
    NetworkError: "نیٹ ورک کا مسئلہ۔ ریفریش کریں یا دوبارہ لاگ ان کریں۔ مدد چاہیے؟ سپورٹ سے رابطہ کریں۔",
    NetworkTimeout: "نیٹ ورک ٹائم آؤٹ",

    user_kicked_out: "آپ کا اکاؤنٹ کہیں اور لاگ ان ہے، اس لیے آپ کو لاگ آؤٹ کر دیا گیا",

    ConfigError: "گیم کنفیگ حاصل کرنے میں ناکامی۔ ریفریش کریں یا دوبارہ لاگ ان کریں۔ مدد چاہیے؟ سپورٹ سے رابطہ کریں۔",

    LoadBundlesError: "بنڈلز لوڈ کرنے میں ناکامی۔ ریفریش کریں یا دوبارہ لاگ ان کریں۔ مدد چاہیے؟ سپورٹ سے رابطہ کریں۔",
    HotUpdateError: "اثاثے لوڈ کرنے میں ناکامی۔ ریفریش کریں یا دوبارہ لاگ ان کریں۔ مدد چاہیے؟ سپورٹ سے رابطہ کریں۔",

    exit_game_title: "ٹپس",
    exit_game_btn_yes: "ہاں",
    exit_game_btn_no: "نہیں",
    exit_game_confirm: "کیا آپ واقعی یہ گیم چھوڑنا چاہتے ہیں؟",
    open_pay_url_confirm: "آپ کو 777 Vegas کی تصدیق شدہ قابل اعتماد تھرڈ پارٹی سائٹ پر ری ڈائریکٹ کیا جائے گا۔ محفوظ طریقے سے جاری رکھنے کے لیے 'ہاں' ٹیپ کریں۔",


    MessageID_Error: "مختصر مدت کی اجرائی کا انتظار",
    MobileNumInvalid: "براہ مہربانی درست فون نمبر درج کریں",
    PwdInvalid: "غلط پاس ورڈ",
    InvalidSmscode: "براہ مہربانی درست OTP درج کریں",
    OTPHasSent: "OTP بھیج دیا گیا ہے۔",
    BindPhoneSuccess: "موبائل شامل ہو گیا! لابی پ واپس جائیں اور کمائی شروع کریں!",

    Not_sign: "یہ ایونٹ صرف VIP کے لیے ہے۔ ابھی ریچارج کریں اور VIP بنیں!",

    VipCardItem_days: "دن",
    VipCardItem_reward_now: "ابھی %s کیش + %s بونس حاصل کریں",  //立即获得%d现金+%d奖金
    VipCardItem_reward_everyDay: "ہر روز %s کیش + %s بونس حاصل کریں",  //每天获得%d现金+%d奖金
    VipCardItem_cash_everyDay: "ہر روز %s کیش حاصل کریں",  //每天获得%d现金
    VipCardItem_bouns_everyDay: "ہر روز %s بونس حاصل کریں",  //每天获得%d奖金
    VipCardItem_try_later: "ادائیگی جاری ہے، براہ مہربانی تھوڑی دیر بعد کوشش کریں۔",  //付款正在进行中，请稍后再试。
    Buy_vip_success: "VIP مراعات خرید لی گئیں!",
    Get_vip_reward_success: "انعامات حاصل ہو گئے!",
    PayChannel_toast: "ڈپازٹ جاری ہے۔ براہ مہربانی صبر سے انتظار کریں۔",

    Vip_Unlocks: "≥ Rs 10 پر انلاک ہوتا ہے",
    ShareModule_click_link: "ہیلو میرے دوست! لنک پر کلک کریں اور ابھی آن لائن بڑا کیش جیتیں!",  //你好，我的朋友!点击链接，立即在线赢取大额现金！
    ShareModule_whatapp_tip: "براہ مہربانی پہلے WhatsApp انسٹال کریں۔",  //请先安装WhatsApp
    ShareModule_Facebook_tip: "براہ مہربانی پہلے Facebook انسٹال کریں۔",  //请先安装Facebook
    ShareText_loadingNum: "%s درست دوست",
    ShareText_loadingNum2: "/%s درست %s دوست",
    ShareText_rule_reward: "وست کا پہلا ڈپازٹ = آپ کو ملے گا:%s",
    ShareText_rule_pay: "دوست کا ہر ڈپازٹ = آپ کو:%s",


    ShareText_rule_level: "≥%s دوست (لیول 1 + لیول 2) نے پہلا ڈپازٹ مکمل کی",

    modify_nickname_success: "نِک نیم کامیابی سے تبدیل ہو گیا",
    modify_user_icon_success: "یوزر آئیکن کامیابی سے تبدیل ہو گیا",

    WithdrawPanel_add_bank: "براہ مہربانی پہلے بینک اکاؤنٹ شامل کریں۔", //请先添加银行账户.
    withdraw_error_1: "Pay TM ID غلط ہے!",
    withdraw_error_2: "ای میل فارمیٹ غلط ہے!",
    withdraw_error_3: "ودڈرا کی رقم خالی ہے!",
    withdraw_error_4: "کم از کم کیش ودڈرا %d ہے۔",
    withdraw_error_5: "تصدیقی کوڈ بھیج دیا گیا",
    withdraw_error_6: "تصدیقی کوڈ غلط ہے!",
    withdraw_error_7: "بینک انفو غلط",
    WithdrawPremiumTips: "صرف VIP ودڈرا کر سکتا ہے۔ ابھی ریچارج کریں اور VIP بنیں!",
    WithdrawSuccessDialog: "ودڈرا کامیاب۔ 15 منٹ سے 24 گھنٹوں میں پہنچ جائے گا۔ ضرورت ہو تو سپورٹ سے رابطہ کریں۔",
    dialog_title_tips: "ٹپس",
    h5_get_user_scores_fail: "نیٹ ورک کمزور ہے، براہ مہربانی دوبارہ کنیکٹ کریں۔",
    h5_get_user_scores_confirm: "کنیکٹ کریں",
    withdraw_tips_content: "آج کی ودڈرا حد ختم۔ کل آئیں یا VIP اپ گریڈ کریں!",
    withdraw_tips_confirm: "تصدیق کریں",
    FillEWalletDialogRs_invalid_number: "اکاؤنٹ نمبر غلط ہے۔ نمبر 0 سے شروع نہیں ہونا چاہیے۔",  //帐号无效。帐号不应从0开始。
    FillBankInfoDialog_add_bank_success: "بینک کارڈ کامیابی سے شامل ہو گیا", //添加银行卡成功
    beneficiary_name: "کا نام درج کریں",  //输入受益人姓名
    BankInfoForms_bank_number: "بینک اکاؤنٹ نمبر درج کریں",  //输入银行账号
    EWalletInfoForms_ewallet_number: "ای والٹ اکاؤنٹ نمبر درج کریں",  //输入电子钱包账号
    EWalletInfoForms_valid_bank_number: "براہ مہربانی درست ای والٹ اکاؤنٹ نمبر درج کریں",  //请输入有效的电子钱包账号
    EWalletInfoForms_same_ewallet_number: "ای والٹ اکاؤنٹ نمبر ایک جیسا ہونا چاہیے",  //电子钱包账号输入必须相同
    EWalletInfoForms_name: "اکاؤنٹ کا نام درج کریں",  //输入账户名字
    EWalletInfoFormsRs_name: "03 xxxxxxxxx", //"Enter Account Number",  //输入账号
    EWalletInfoFormsRs_ID_number: "03 xxxxxxxxx",//"Enter ID Card Number",  //输入身份证号码
    FillBankInfoDialog_IFSC_number: "IFSC کوڈ نمبر درج کریں",  //输入IFSC代码
    EWalletInfoFormsRs_valid_name: "براہ مہربانی درست اکاؤنٹ نام درج کریں",  //请输入有效的账户
    EWalletInfoFormsRs_valid_number: "براہ مہربانی درست اکاؤنٹ نمبر درج کریں",  //请输入有效的帐号
    EWalletInfoFormsRs_same_number: "اکاؤنٹ نمبر ایک جیسا ہونا چاہیے",  //帐号输入必须相同
    EWalletInfoFormsRs_valid_ID_number: "براہ مہربانی درست ID کارڈ نمبر درج کریں", //请输入有效的身份证号码
    FillBankInfoDialog_valid_IFSC_number: "براہ مہربانی درست IFSC کوڈ درج کریں",  //请输入有效的IFSC代码
    FillBankInfo_Error: "IFSC کوڈ غلط ہے۔ براہ مہربانی دوبارہ درج کریں۔",
    FillBankInfoFifth_Error: "IFSC کوڈ کا 5واں حرف '0' ہونا چاہیے",
    valid_name: "براہ مہربانی درست نام درج کریں",  //请输入有效的受益人姓名
    bank_name: "بینک کا نام درج کریں",  //输入银行名称
    valid_bank_number: "براہ مہربانی درست بینک اکاؤنٹ نمبر درج کریں",  //请输入有效的银行帐号
    same_bank_number: "بینک اکاؤنٹ نمبر ایک جیسا ہونا چاہیے",  //银行账号输入必须相同
    valid_bank_name: "براہ مہربانی درست بینک نام درج کریں",  //请输入有效的银行名称
    houseRace_winTxet: "مبارک ہو! %s نے %s میں %s جیتا!",  //跑马灯恭喜中奖
    tips: "ٹپس",  //提示
    confirm: "تصدیق کریں",  //确认
    notice: "نوٹس", //通知
    Notice: "نوٹس", //通知大写
    yes: "ہاں", //是的
    no: "نہیں", //不是

    transaction_no_more_data: "مزید ٹرانزیکشن ڈیٹا نہیں",
    transaction_is_first_page: "یہ پہلا صفحہ ہے",
    AddCashModule_failFun_tip: "براہ مہربانی نیٹ ورک چیک کریں اور دوبارہ کوشش کریں", //请检查网络并重试
    AddCashPayH5: "%s سیکنڈز کے بعد دوبارہ بٹن کلک کریں",

    can_find_subgame_info: "گیم کی معلومات نہیں مل سکی",
    subgame_is_closed: "یہ گیم جلد آ رہی ہے",

    VipEquityView_showLevelUi_Recharge: "Rs %s ریچارج کریں اور VIP%s بنیں",
    VipEquityView_showCloseTip_weelpar: "ہفتہ وار بیٹنگ رقم ≥ %s",
    VipEquityView_showCloseTip_halfMonthpar: "نصف ماہانہ بیٹنگ رقم ≥ %s",
    VipEquityView_showCloseTip_Monthpar: "ماہانہ بیٹنگ رقم ≥ %s",

    TransactionPanel_activity: "سرگرمی", // 游戏记录 - 文字 - 活动
    TransactionPanel_money_add: "رقم شامل", // 游戏记录 - 文字 - 添加货币
    TransactionPanel_withdrawal: "ودڈرا", // 游戏记录 - 文字 - 退出
    TransactionPanel_win: "جیتا گیا ", // 游戏记录 - 文字 - 赢
    TransactionPanel_loss: "ہارا گیا ", // 游戏记录 - 文字 - 输

    UnPay: "جاری", // 提现中
    FinishPay: "کامیاب", // 成功
    PayFail: "ناکام", // 提现失败

    WithdrawFail: "غیر معمولی ناکامی", // 提现异常失败
    WithdrawFailHandled: "غیر معمولی ناکامی حل ہو گئی", // 异常失败已处理
    WithdrawRejected: "مسترد", // 提现已拒绝

    Vip_ERROR: "نیٹ ورک چیک کریں",
    VipRewardGetToday: "آج حاصل ہو گیا",
    VipRewardTime: "میعاد ختم ہونے میں",
    PayAmount: "ریچارج کی رقم", // "充值金额:",
    Arrived: "موصول ہو گیا", // "已到账!",

    CopySuccess: "کامیابی سے کاپی ہو گیا",
    CopyFail: "کاپی ناکام ہو گئی",
    CopyString: "\nہیلو میرے دوست! لنک پر کلک کریں اور ابھی آن لائن بڑا کیش جیتیں!", //复制后半段
    MoreClick: "مزید ایونٹس جلد آ رہے ہیں۔",
    EggCapsuleStart: "شروع کریں (%s)",
    EggCapsuleStartEnd: "شروع ہو رہا ہے",
    EggCapsuleErroe: "سرگرمی ڈیٹا میں خرابی",
    Sharing_link_error: "شیئر لنک میں خرابی",//分享链接错误
    WelcomeTip1: "پہلا ڈپازٹ انعام %s% حاصل کریں",
    WelcomeTip2: "دوسرا ڈپازٹ انعام %s% حاصل کریں",
    WelcomeTip3: "تیسرا ڈپازٹ انعام %s% حاصل کریں",

    BindActivityReward: "ویلکم انعامات",
    BindActivityBonus: "ڈائمنڈز کنورٹ",
    BindActivityDailyCash: "روزانہ کیش",
    BindActivityVipCard: "VIP کارڈ",
    BindActivityVIPPrivilege: "VIP مراعات",
    BindActivityLuckyWheel: "لکی وہیل",
    BindActivityLuckyGacha: "Lucky Gacha",
    BindActivityRich1: "انعام تک",
    BindActivityRich2: "ڈائمنڈز کو مفت کیش میں انلاک کریں",
    BindActivityRich3: "ہر روز مفت کیش حاصل کریں",
    BindActivityRich4: "انعامات تک",
    BindActivityRich5: "اپنے VIP انعامات حاصل کریں",
    BindActivityRich6: "<color=#FFFFFF>دوستوں کو ریفر کریں = </color><color=#FF3838>2K</color><color=#FFFFFF> ڈائمنڈز مفت!</color>",
    BindActivityRich7: "گھمائیں اور جیتیں",
    BindActivityRich8: "<color=#FFFFFF>ریفر کریں اور جیتیں </color><color=#FFD663>8,888 Rs</color><color=#FFFFFF> مفت کیش!</color>",
    BindActivityRich9: "<color=#FFFFFF>صرف پہلا ڈپازٹ → 200% بونس!</color>",
    BindActivityRich10: "<color=#FFFFFF>مفت کیش Rs 100,000 تک!</color>",
    BindActivityRich11: "مفت کیش Rs 100,000 تک!",
     BindActivityRich12: "<color=#FFFFFF>Claim </color><color=#FFD663> Rs 77,777</color><color=#FFFFFF> Everyday!</color>",
    BindActivityRich13: "<color=#FFFFFF>Win </color><color=#FFD663>Rs 7777 </color><color=#FFFFFF>Or </color><color=#FFD663> 500 </color><color=#FFFFFF>Spins!</color>",
    FreeSpinEverydayTip: "مفت اسپنز – سلاٹس مفت کھیلیں!",

    Game_type_name_palyer: 'حال ہی میں کھیلی گئی',
    Game_type_name_hot: 'ہاٹ گیمز',
    Game_type_name_slots: 'سلاٹس گیمز',
    Game_type_name_tableCard: 'ٹیبل اور کارڈ',
    Game_type_name_crash: 'کریش گیمز',
    Game_type_name_arcade: 'آرکیڈ',
    Game_type_name_fishing: 'فشنگ',
    Game_type_name_casino: 'لائیو کیسینو',
    Game_type_name_lottery: 'لاٹری',

    Game_provider_All: 'تمام',
    Game_provider_PG: 'PG',
    Game_provider_JILI: 'JILI',
    Game_provider_SP: 'Spribe',
    Game_provider_CQ9: 'CQ9',
    Game_provider_EV: 'Evolution',
    Game_provider_PP: 'Pragmatic Play',
    Game_provider_JDB: 'JDB',
    Game_provider_TADA: 'TADA',
    Game_provider_RED: 'Red Tiger',
    Game_provider_FaChai: 'FaChai',
    Game_provider_BNG: 'BNG',
    Game_provider_Hacksaw: 'Hacksaw',
    Game_provider_Bgaming: 'Bgaming',
    Game_provider_NextSPIN: 'NextSPIN',
    Game_provider_WONWON: 'WONWON',
    Game_provider_AOG: 'AOG',
    Game_provider_V8: 'V8',
    Game_provider_InOut: 'InOut',
    Game_provider_KoolBet: 'KoolBet',
    Game_provider_Mini: 'Mini',

    SubgameInfoTip1: "کم بیلنس۔ ابھی ڈپازٹ کریں۔",
    SubgameInfoTip2: "تمام بیلنس بیٹ لگانے کے لیے استعمال ہو سکتے ہیں۔",
    SubgameInfoTip3: "مفت کیش بیلنس اس گیم میں بیٹ کے لیے استعمال نہیں ہو سکتا۔",
    VipConversionTip: "<size=20><color=#ffffff>بیٹنگ کرنے پر ڈائمنڈز مفت کیش میں تبدیل ہو جائیں گے۔\nآپ کی کنورژن ریٹ ہے </color>",
    vipCardUp: "حاصل کریں",
    vipEquiteConversion1: "<size=14><color=#FFD223>VIP",
    vipEquiteConversion2: "<color=#ffffff> کنورژن ریٹ: </color>",

    rolloverAllType: "تمام اقسام",
    rolloverDeposit: "ڈپازٹ",
    rolloverFreeCash: "مفت کیش",
    RolloverALLSTATUS: "تمام سٹیٹس",
    RolloverNOTSTARTED: "شروع نہیں ہوا",
    RolloverONGOING: "جاری",
    RolloverCOMPLETED: "مکمل ہو گیا",
    RolloverCANCELED: "منسوخ",

    TurnTableTips: " نے ابھی حاصل کیا",
    TurnTableReward1: " MacBook Pro 16 انچ",
    TurnTableReward2: " iPhone 17 Pro ",
    TurnTableReward3: "مفت اسپن x2",
    TurnTableReward4: " مفت اسپن x1",
    TurnTableReward5: " مفت کیش",
    TurnTableError: "کوئی بھی رقم ڈپازٹ کریں اور 1 اسپن کا موقع حاصل کریں۔",

    updateLoading: "لوڈ ہو رہا ہے... %s%",
    vipCardRedTip: "حاصل کریں",
    vipTip: "VIP ٹپ",

    rankDailyTimeTip: " شماریات: %s(00:00 - 24:00)",
    rankWeekTimeTip: "شماریات: %s سے %s تک (00:00 - 24:00)",

    rankClickDailyTip: `<color=#fff9c0>آپ نے</color><color=#fddb1c> %sویں </color><color=#fff9c0>روزانہ رینکنگ میں حاصل کیا اور جیتا</color>`,
    rankClickWeeklyTip: `<color=#fff9c0>آپ نے</color><color=#fddb1c> %sویں </color><color=#fff9c0>ہفتہ وار رینکنگ میں حاصل کیا اور جیتا</color>`,


    vip_tip_withdrawal_desc2: "<color=#EBEBEB>مزید کے لیے اپ گریڈ کریں</color>",
    vip_tip_withdrawal_desc: "<color=#FF0000>VIP%s: %s روزانہ ودڈراز.</color><color=#EBEBEB>مزید کے لیے اپ گریڈ کریں</color>",
    GameListAmount: "<color=#898989>موجودہ </color><color=#ea4e51>%s/%s</color><color=#898989> گیمز</color>",

    PddBanlance2: "<color=FFD663>آپ نے کر دکھایا! %s حاصل۔ ابھی پیسہ حاصل کریں!</color>",
    PddBanlance: "<color=#ECEBEB>صرف </color><color=#FFD663>%s </color><color=#ECEBEB>مزید اور آپ </color><color=#FFD663>%s</color><color=#ECEBEB> حاصل کر سکیں گے!</color>",
    PddBanTip: "<color=#ECEBEB>گرم خبر! </color><color=#FFFFFF>%s </color><color=#ECEBEB>نے ابھی </color><color=#FFFFFF>%s</color><color=#ECEBEB> حاصل کیا!</color>",
    PddTurnTableError: "دوستوں کو رجسٹر کرنے اور موبائل باندھنے کی دعوت دیں تاکہ مزید اسپنز حاصل کریں۔",
    PddGet2: "حاصل ہو گیا! تفصیلات کے لیے والٹ چیک کریں۔",
    panelShowErroe: "ڈیٹا میں خرابی",
    Loggings: "لاگ ان ہو رہا ہے",
    PddTurnTableError2: "براہ مہربانی انعام حاصل کریں",
    PddStatus1: "جاری",
    PddStatus2: "کامیاب",
    PddStatus3: "ختم ہو گیا",
    PddFreeCash: "%s مفت کیش",
    PddDownTime: "( %ss )",
    achieved: "حاصل ہو گیا",

    gotoLine: "آپ کو تھرڈ پارٹی ویب سائٹ پر ری ڈائریکٹ کیا جائے گا۔ جاری رکھنے کے لیے ہاں کلک کریں۔",
    MinBet: "از کم بیٹ: Rs %s",
    Logging: "لاگ ان ہو رہا ہے",

    UsernameTip: "صرف 4-12 حروف/نمبر",
    Password: "صرف 6-12 حروف/نمبر",
    Deleted: "کامیابی سے ڈیلیٹ ہو گیا!",
    IsKBZError: "یہ KBZ Pay کسی اور یوزر نیم سے منسلک ہے۔ مختلف درج کریں۔",
    ResigsterError: "ڈیوائس رجسٹریشن حد تک پہنچ گئی۔",


    LoginNewSuccess: "اکاؤنٹ کامیابی سے شامل، براہ مہربانی واپس جا کر دوبارہ لاگ ان کریں!",
    UsernameError: "غلط یوزر نیم! صرف 4-12 حروف/نمبر",
    UsernameError2: "یوزر نیم پہلے سے استعمال میں! دوبارہ درج کریں۔",
    UsernameError3: "یوزر نیم نہیں ملا! دوبارہ درج کریں یا رجسٹر کریں۔",
    UsernameError4: "درست ذاتی اکاؤنٹ نام درج کریں",
    PasswordError: "غلط پاس ورڈ! صرف 6-12 حروف/نمبر",
    PasswordError2: "پاس ورڈ مماثل نہیں! دوبارہ درج کریں۔",
    PasswordError3: "غلط پاس ورڈ! دوبارہ درج کریں۔",
    PasswordError4: "یوزر نیم اور فون نمبر مماثل نہیں! دوبارہ درج کریں۔",
    PhoneError: "غلط فون نمبر! دوبارہ درج کریں۔",
    PhoneError2: "فون نمبر پہلے سے استعمال میں! دوبارہ درج کریں۔",
    PhoneError3: "درج نمبر اصل فون نمبر سے مماثل نہیں۔ چیک کریں!",
    PhoneErrorotp: "OTP غلط ہے، براہ مہربانی دوبارہ درج کریں",

    pinRule1: "1. جب جمع شدہ رقم مطلوبہ حد تک پہنچ جائے تو آپ ودڈرا انعام کی درخواست کر سکتے ہیں۔",
    pinRule2: "2. ہر دوست جو آپ کی دعوت سے موبائل نمبر باندھے گا، آپ کو ایک مفت اسپن ملے گا۔",
    pinRule3: "3. پروموشن 3 دن تک چلے گی۔ مدت ختم ہونے پر تمام جمع انعامات ری سیٹ ہو جائیں گے اور پروموشن دوبارہ شروع ہو گی",
    pinRule4: "4. ہر یوزر کو روزانہ 1 مفت اسپن مل سکتا ہے۔ اسپن کی گنتی روزانہ 24:00 پر ری سیٹ ہوتی ہے",
    pinRule5: "5. ایک ہی ڈیوائس یا IP سے بار بار دعوت یا رجسٹریشن سختی سے منع ہے۔",
    pinRule6: "6. انعامات ودڈرا کرنے سے پہلے x10 ویجرنگ کی شرط کے تابع ہیں",
    pinRule7: "7. 777 Vegas Win کو رولز تبدیل کرنے کا حق محفوظ ہے۔ اگر کوئی دھوکہ دہی، غلط استعمال یا نقصان دہ سرگرمی پائی گئی تو انعامات منسوخ کرنے اور اہلیت ختم کرنے کا حق محفوظ ہے",

    waterPar: "<color=#ffffff>بیٹ </color> <color=#FBE496> %s </color><color=#ffffff>کھولنے کے لئے مزید</color> <color=#FBE496> %s </color>",
    waterParSpin: "<color=#ffffff> ابھی گھمائیں </color><color=#FBE496> %s </color>",

    BonanzaParSpinNeed: "<color=#ffffff>مزید ڈپازٹ کریں </color><color=#FBE496> %s </color><color=#ffffff>بونس حاصل کرنے کے لیے  </color><color=#FBE496> %s </color>",
    BonanzaParSpin: "<color=#ffffff>پ کے پاس </color><color=#FBE496> %s </color><color=#ffffff> حاصل کرنے کے لیے منتظر ہیں</color>",
    BonanzaParSpinEnd: "<color=#ffffff> بونس حاصل کر لیا ہے</color><color=#FBE496> %s </color><color=#ffffff>آپ نے </color>",

    enough: "کافی چپس نہیں!", // "金币不足",
    ClaimAll: "سب حاصل کریں",
    Claimed: "دعوی",
    TotalBetToday: "آج کی کل بیٹ %s",
    TotalDepositToday: "آج کی کل ڈپازٹ %s",
    DailyTaskReward: "روزانہ ٹاسک انعام",
    MysteryTreasureReward: "مسٹری ٹریژر انعام",
    active: "فعال",//
    Failed: "ناکام ہو گیا",

    marqueLabel: "<color=#FFFFFF>%s</color><color=#FFD663> Won %s 🎉</color>",
    jackLabel: "<color=#FFFFFF> زبردست جیت </color>",
    jackpotTip: "براہِ کرم ایک دوست کو مدعو کریں تاکہ مفت اسپن حاصل کر سکیں",
    friends : "دوستوں",
    Reachfriends : "تک پہنچیں VIP%s",
    jackpotSpins : "باقی اسپنز:",

    WithdrawTips : "اپنے VIP لیول کو اپ گریڈ کریں، زیادہ ودڈرال کے فوائد حاصل کریں۔",
    otpTip: "OTP غلط ہے، براہ مہربانی دوبارہ درج کریں",
    FirstTip: '%s نے ابھی %s جمع کرایا ہے',
    Claimsin: '%s میں کلیم کریں',
    MysticBoxTip: '<color=#ffffff>روزانہ ڈپازٹ ≥</color><color=#FFD663> Rs %s </color><color=#ffffff> حاصل کرنے کے لیے </color><color=#FFD663> %s </color></color><color=#ffffff> کلیمز </color>',
    marqueLabel1: '<color=#FFFFFF>%s</color><color=#FFD663> نے %s جیتا 🎉</color>',
    marqueLabel2: '<color=#FFFFFF>%s</color><color=#FFD663> نے %s جمع کرایا 🎉</color>',
    marqueLabel3: '<color=#FFFFFF>%s</color><color=#FFD663> نے %s ودڈرا کیا 🎉</color>',
    AccountPanel_wallets: 'والٹس',
    AccountPanel_vip: 'VIP',
    AccountPanel_records: 'ریکارڈز',
    AccountPanel_rollover: 'رول اوور',
    AccountPanel_mail: 'میل',
    AccountPanel_support: 'سپورٹ',
    AccountPanel_setting: 'سیٹنگز',
    AccountPanel_language: 'زبان',
    AccountPanel_deposit: 'ڈپازٹ',
    AccountPanel_withdraw: 'ودڈرا',
    Language_select_title: 'زبان منتخب کریں',
    Language_en: 'English',
    Language_pak: 'Urdu (اردو)',
}
